import { BaseError } from './BaseError';

export class InvalidEnvironmentError extends BaseError {
    constructor() {
        super(`The current environment does not support this operation.`);

        Object.setPrototypeOf(this, InvalidEnvironmentError.prototype);
    }
}
